// #region imports

// --- Angular
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';

// --- RxJs
import { Observable } from 'rxjs';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class AddCsrfInterceptorService implements HttpInterceptor {
  constructor() {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const requestToken = this.getCookieValue('XSRF-REQUEST-TOKEN');
    return next.handle(
      req.clone({
        headers: req.headers.set('X-XSRF-TOKEN', requestToken)
      })
    );
  }

  private getCookieValue(cookieName: string) {
    const allCookies = decodeURIComponent(document.cookie).split('; ');
    for (const cookie of allCookies) {
      if (cookie.startsWith(cookieName + '=')) {
        return cookie.substring(cookieName.length + 1);
      }
    }
    return '';
  }
}
